export default {
    rowSelection: false,
    fieldControl: false,
    pagination: false,
    searchFormConfig: {
      labelCol: {
        xs: {span: 24},
        sm: {span: 8},
        xl: {span: 10},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
        xl: {span: 14},
      },
    },
    scroll: {y: 350},
    columns: [
      {
        title: '任务类型',
        dataIndex: 'taskType',
        width: 160,
        fixed: 'left',
        render: 'taskTypeRender'
      },
      {
        title: '线索ID',
        dataIndex: 'clueId',
        width: 180,
        render: 'clueIdRender'
      },
      {
        title: '客户姓名',
        dataIndex: 'customerName',
        width: 160,
        render: 'nameRender'
      },
      {
        title: '客户电话',
        dataIndex: 'customerPhone',
        width: 160,
      },
      {
        title: '操作',
        dataIndex: '#',
        render: 'actionRender',
        width: 120,
      }
    ],
   
    footer: [
    ],
  };
  